import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34a9fc24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rotate" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "PLEASE, ROTATE YOUR PHONE.", -1))

import { onMounted, onUnmounted, ref } from 'vue'
import UIPanel from '@/components/UIPanel/UIPanel.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = ref(false)

onMounted(() => {
  window.addEventListener('resize', onResize)
  onResize()
})

onUnmounted(() => {
  window.removeEventListener('resize', onResize)
})

const onResize = () => {
  const {innerWidth, innerHeight} = window
  const ratio  = innerWidth / innerHeight
  if (ratio > 1.2) {
    show.value = true
  } else {
    show.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(UIPanel, null, {
          heading: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, show.value]
      ])
    ]),
    _: 1
  }))
}
}

})